/* global  attachEvent */

// **********************************************************
// Gallery popup
// **********************************************************

attachEvent('.gallery__item', 'click', (ev) => {
  const parentElem = ev.target.closest('.gallery');
  const galleryPopup = parentElem.querySelector('.gallery-popup');
  galleryPopup.classList.add('is-open-modal');
  document.body.classList.add('is-open-modal');
});

attachEvent('.gallery-popup__close', 'click', (ev) => {
  const parentElem = ev.target.closest('.gallery-popup');
  parentElem.classList.remove('is-open-modal');
  document.body.classList.remove('is-open-modal');
});
